import { CodebookModel } from 'app/shared/model/shared.model';

export interface PublicAuthorityOverviewRow {
  idPublicAuthority: number;
  publicAuthority: string;
  oib: string;
  affiliations: string;
  address: string;
}

export interface PublicAuthorityOverviewFilterModel {
  oib: string;
  fullName: string;
  county: CodebookModel[];
  cityMunicipality: CodebookModel[];
}

export const initialPublicAuthorityFilterValues: PublicAuthorityOverviewFilterModel = {
  oib: '',
  fullName: '',
  county: [],
  cityMunicipality: [],
};
